import { manageDatabaseActionTypes } from '../constants/ApiConstants';

const initialState = {
    loading: false,
    organizationDatabaseDetail: [],
    savedOrganizationData: null,
    deletedOrganisationData: {}
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case manageDatabaseActionTypes.getOrganizationDatabaseDetail.REQUEST:
            return {
                ...state,
                loading: true,
            }
        case manageDatabaseActionTypes.getOrganizationDatabaseDetail.SUCCESS:
            return {
                ...state,
                loading: false,
                organizationDatabaseDetail: payload,
            }
        case manageDatabaseActionTypes.post_database.REQUEST:
            return {
                ...state,
                loading: true,
            }
        case manageDatabaseActionTypes.post_database.SUCCESS:
            return {
                ...state,
                loading: false,
                savedOrganizationData: payload
            }
        case manageDatabaseActionTypes.delete_database.REQUEST:
            return {
                ...state,
                loading: true
            }
        case manageDatabaseActionTypes.delete_database.SUCCESS:
            return {
                ...state,
                loading: false,
                deletedOrganisationData: payload
            }
        default:
            return state;
    }
} 


// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageDataBase/reducers/ManageDataBaseReducer.js